import md5 from 'crypto-js/md5';

export const SECRET = "5ea684f13c0b27d9";

const encrypt = (id) => {
    // create hash and make first and ast part
    const hash = md5hash(id+"").substr(0, 16);
    const first = hash.substr(0, 8);
    const last = hash.substr(8, 8);
    
    // get random position and encode it
    const pos = randomIntFromInterval(0,15);
    const chipherPos = SECRET.charAt(pos);
    const index = pos % 8;
    
    // get random shift value and encode it
    const shift = randomIntFromInterval(0,15);
    const chipherShift = SECRET.charAt(shift);
    
    // shift secret
    const secret2 = SECRET.substr(shift) + SECRET.substr(0, shift);
    
    // get length of id and encode it
    const length = (""+id).length;
    const chipherLength = secret2.charAt(length);
    
    // first part = hash first part + position + shift + length
    const firstPosShiftLength = chipherPos+first.substring(0, index)+chipherShift+chipherLength+first.substring(index);
    
    // encrypt id
    const chipherId = encryptId(id, secret2);
    
    // last part = hash last part + id
    const lastId = chipherId+last;
    //decrypt(firstPosShiftLength+lastId);
    
    console.log(firstPosShiftLength + lastId);
    return firstPosShiftLength + lastId;
}

const encryptId = (id, secret) => {
    const str = ""+id;
    const length = str.length;
    let chipher = "";
    
    for(let i = 0; i < str.length; i++) {
        let num = str.substring(i,i+1);
        chipher += secret.charAt(num);
    }

    return chipher;
}

const decrypt = (str) => {
    // first part = hash first part + position + shift + length
    const firstPosShiftLength = str.substring(0,11);
    // last part = hash last part + id
    const lastId = str.substring(11);
    
    // chipher position always at index 0
    const chipherPos = str.charAt(0);
    // get pos and index (index > 8 start from 0)
    const pos = SECRET.indexOf(chipherPos);
    const index = pos % 8;
    
    // extract pos from first part
    const firstShiftLength = firstPosShiftLength.substring(1);
    
    // get shift from index
    const chipherShift = firstShiftLength.charAt(index);
    const shift = SECRET.indexOf(chipherShift);
    
    // shift secret
    const secret2 = SECRET.substr(shift) + SECRET.substr(0, shift);
    
    // get length from index +1
    const chipherLength = firstShiftLength.charAt(index+1);
    const length = secret2.indexOf(chipherLength);
    
    // extract shift and length from hash
    const firstPart = firstShiftLength.substring(0, index) + firstShiftLength.substring(index+2);
    
    console.log(pos,index,chipherPos,shift,chipherShift,length,chipherLength);
    
    // get hash last part
    const lastPart = lastId.substring(length);
    
    // get id
    const chipherId = lastId.substring(0, length);
    const id = decryptId(chipherId, secret2);
    
    // create hash
    const hash = firstPart + lastPart;
    
    if(md5hash(id).substr(0, 16) === hash) {
       return id; 
    }
    
    return false;
}

const decryptId = (id, secret) => {
    const chipher = ""+id;
    const length = chipher.length;
    let str = "";
    
    for(let i = 0; i < chipher.length; i++) {
        let num = chipher.substring(i,i+1);
        str += secret.indexOf(num);
    }

    return str;
}

const randomIntFromInterval = (min, max) => { // min and max included 
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export const md5hash = (str) => {
    //console.log(md5(str).toString());
    return md5(str).toString();
}

/*
const checksum = (id) => {
    const str = PICTURE_SERVER.base + id + "p0";
    //console.log(md5hash(str).substr(0, 16));
    return md5hash(str).substr(0, 16);
}

const url = (id) => {
    //console.log(PICTURE_SERVER.url + id + PICTURE_SERVER.params + checksum(id));
    return PICTURE_SERVER.url + id + PICTURE_SERVER.params + checksum(id);
}
*/
export { /*url,*/ decrypt, encrypt };
